<template>
    <!-- что важно родителям-->
    <div class="block-parents">
        <div class="block-parents__body">
            <div class="block-parents__content">
                <span class="block-parents__title">Что важно <br> родителям</span>
                <div class="block-parents__box block-parents__box-one">
                    <p class="block-parents__text block-parents__text-one">
                        Когда ребенку исполняется семь, родителей можно поздравить: они второй раз идут в школу. Теперь в телефоне десяток новых чатов: «Родительский совет», «Елка»  или «Ярмарка ко Дню матери». Вечером один из родителей лепит сыроежки к уроку технологии, а другой — подстраивает рабочий график под окончание занятий.
                        <br><br>
                        Со второго класса многие дети уже способны возвращаться из школы самостоятельно. Раньше за безопасность ребенка отвечали лично родители, теперь им помогает закрытый двор, подъезд с домофоном и&nbsp;камеры видеонаблюдения.
                    </p>
                    <BlockParallax
                        fixed
                        speed="20"
                        direction="top"
                        transform="translateY"
                        class="block-parents__img-box block-parents__img-box-one"
                    >
                        <img
                            srcset="../assets/5-img.jpg, ../assets/5-img@2x.jpg 2x"
                            src="../assets/5-img.jpg"
                            class="block-parents__img"
                        >
                        <div class="image-caption">Школа в проекте «Ярославский»</div>
                    </BlockParallax>
                </div>
                <div class="block-parents__box block-parents__box-two">
                    <p class="block-parents__text block-parents__text-two">
                        Взрослеющему ребенку одновременно хочется родительской любви и быть самостоятельным. Первые проявления подросткового кризиса скрасит собственная комната или хотя бы место в квартире, где&nbsp;ребенок сможет уединиться.
                    </p>
                    <BlockParallax
                        fixed
                        speed="12"
                        direction="top"
                        transform="translateY"
                        class="block-parents__img-box block-parents__img-box-two"
                    >
                        <img
                            srcset="../assets/6-img-1.jpg, ../assets/6-img-1@2x.jpg 2x"
                            src="../assets/6-img-1.jpg"
                            class="block-parents__img"
                        >
                    </BlockParallax>
                </div>
            </div>
            <BlockParallax class="block-parents__icon block-parents__bag block-parents--icon-desktop" speed="15">
                <img src="@/assets/images/icons/bag.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__skate-2 block-parents--icon-desktop" speed="5">
                <img src="@/assets/images/icons/skate-2.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__ball block-parents--icon-desktop" speed="3" direction="left">
                <img src="@/assets/images/icons/ball.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__nb block-parents--icon-desktop" speed="10" direction="left">
                <img src="@/assets/images/icons/nb-2.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__skate-1 block-parents--icon-desktop" speed="8" direction="left">
                <img src="@/assets/images/icons/skate-1.png">
            </BlockParallax>
        </div>
        <div class="block-parents__mini-block mini-block">
            <div class="mini-block__title">
                <h4>Беговелы, самокаты и&nbsp;скейты: что и когда понадобится вашему ребенку</h4>
                <a href="https://pikabu.ru/story/_7107274" class="mini-block__button" target="_blank">
                    <span>Читать на Пикабу</span>
                </a>
            </div>
            <div class="mini-block__image">
                <img src="../assets/612-mini.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-parents {
        margin-top 3rem
        position relative
        +layout-md-and-up() {
            margin-top 6rem
        }
        &__body {
            position relative
            +layout-md-and-up() {
                display flex
            }
        }
        &__box-one {
            margin-top 2.2rem
            +layout-md-and-up() {
                display: flex
            }
            +layout-md-and-up() {
                padding-left: 8rem
            }
        }
        &__box-two {
            +layout-md-and-up() {
                display: flex
                flex-direction row-reverse
                margin-left: -6rem
            }
        }
        &__title {
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            margin-top 0
            color $color-text
            font-weight $font-semiBold
            display block
            +layout-sm-and-up() {
                text-align: center
                padding: 0
            }
            +layout-md-and-up() {
                font-size 3rem
                margin-top 0.5rem
                line-height 3.5rem
                text-align left
                padding-left: 8rem

            }

        }
        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.6rem 0 0 0
            +layout-md-and-up() {
                max-width 35rem
                padding: 0
            }
        }
        &__text-one {

        }
        &__text-two {
            +layout-md-and-up() {
                max-width 34rem
            }
        }
        &__img-box-one {
            margin-left -1rem
            margin-right -1rem
            margin-top 2rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left auto
            }
            +layout-md-and-up() {
                margin-top -9rem
                margin-left 5rem
            }
        }
        &__img-box-two {
            padding-left 3rem
            margin-right -1rem
            margin-top 2.5rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left: auto
                margin-right: auto
                padding-left: 0
            }
            +layout-md-and-up() {
                margin-left 6rem
                margin-top 9rem
            }
        }
        &__img {
            width: 100%
            margin-left auto
            display block
            +layout-sm-and-up() {
                align-self flex-start
                margin-right: 0
            }
        }

        &__icon {
            position absolute
            pointer-events none
            user-select none
        }
        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__bag {
            top 55rem
            width 8rem
            +layout-md-and-up() {
                top auto
                width auto
                bottom -20rem
                left -25rem
            }
        }
        &__skate-1 {
            +layout-md-and-up() {
                bottom -18rem
                right -12%
            }
        }
        &__skate-2 {
            +layout-md-and-up() {
                bottom 0rem
                left 5rem
                right 7rem
                width 17rem
                margin 0 auto
            }
        }
        &__ball {
            +layout-md-and-up() {
                bottom 38rem
                right -17rem
            }
        }
        &__nb {
            +layout-md-and-up() {
                bottom 18rem
                left -15rem
            }
        }
    }
    .mini-block {
        clear both
        display block
        width 100%
        max-width 640px
        margin 5rem auto
        display flex
        flex-direction row
        flex-wrap nowrap
        &__title {
            max-width 320px
            h4 {
                padding-bottom 31px
                font-size 24px
                font-weight 600
                letter-spacing 0.26px
                line-height 1.44
                color: #222222
            }
        }
        &__button {
            padding 13px 39px 14px
            font-size 16px
            font-weight 600
            letter-spacing 0.17px
            border-radius 5px
            background-color #66bd5a
            color #fff
            &:hover {
                background-color #51bf42
            }
        }
        &__image {
            img {
                width auto
                max-height 215px
            }
        }
        @media screen and (max-width: 700px) {
            max-width 410px
            flex-direction row-reverse
            &__image {
                overflow hidden
                width 8rem
                height 8rem
                border-radius 50%
                margin-right 2rem
                
                img {
                    width auto
                    height 100%
                }
            }
        }
        @media screen and (max-width: 470px) {
            padding 1rem
            &__image {
                display none
            }
        }
    }
</style>
